<template>
  <a-card :bordered="false">

    <div>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        bordered
      >
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
        <v-pagination
          v-if="total"
          :page-num="form.pageNum"
          :page-size="form.pageSize"
          :total="total"
          @change="handleTableChange" />
      </div>
    </div>
  </a-card>
</template>

<script>
import { collectionAccountTradeFlowList } from '@/webpublicapi/CollectionAccountInfo'
import { filterObj } from '@/utils/util'
export default {
  name: 'collectionAccountTradeFlowModule',
  components: {},
  props: {
    mobileNo:{
      type: [String, Number],
      default: undefined,
    },
    flowType:{
      type: [String, Number],
      default: undefined,
    },
  },
  data () {
    return {
      dataSource: [],
      loading: false,
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      // Query conditions
      queryParam: {
        mobileNo:"",
        flowType: null
      },
      title: 'Action',
      visible: false,
      model: {}
    }
  },
  computed: {
    columns () {
      return [
        {
          title: "Bank CardNo.",
          align: 'left',
          dataIndex: 'bankCardNo'
        },
        {
          title:  "Transaction Status",
          align: 'left',
          dataIndex: 'tradeStatus',
          customRender: (text) => {
            // 00-In transaction 01-Transaction success 02-Transaction refund 03-Transaction cancelled 04-Transaction failed 05-In transaction queue
            if ("00" === text) {
              return "Transaction in ";
            } else if ("01" === text) {
              return "Transaction Success";
            } else if ("02" === text) {
              return "Transaction Refund";
            } else if ("04" === text) {
              return "Transaction Failed";
            }
            return text;
          }
        },
        {
          title: 'Amount',
          align: 'left',
          dataIndex: 'tradeAmount'
        },
        {
          title:'Created Time',
          align: 'left',
          dataIndex: 'createdTime'
        },
        {
          title: 'Salary Belonging Date',
          align: 'left',
          dataIndex: 'tradeTime'
        }
      ]
    },
  },
  created () {
    this.queryParam.mobileNo = this.mobileNo;
    this.queryParam.flowType = this.flowType;
    this.loadData()
  },
  methods: {
    loadData () {
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      collectionAccountTradeFlowList(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
    getQueryParams () {
      const data = {
        ...this.queryParam
      }
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum;
      param.pageSize = this.form.pageSize;
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
      this.form.pageNum = pageNum;
      this.form.pageSize = pageSize;
      this.loadData();
    }
  }
}
</script>
<style scoped>

</style>
